<div class="container-fluid p-0" id="control-hub-container" style="height:100%;">
	<router-outlet></router-outlet>
</div>